import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal, Row, Col } from "reactstrap";
import {
  CHECK_ERROR,
  CHECK_WARNING,
} from "../../../../../../components/alert/Alert";
import FormControl from "../../../../../../components/base/Form/FormControl";
import {
  BatchEndpoint,
  BoSungVanDesEndpoint,
} from "../../../../../../service/Meet";
import { formDataVD } from "./data";
import PhuongAns from "./PhuongAns";
import { Enums_LoaiBieuQuyet } from "../../../../../action/defaultEnums";
import { FontAwesome } from "../../../../../../components/icon";
import { v4 as uuid } from "uuid";
import ThamDus from "./ThamDus";
import DeniedBoSungVanDesEndpoint from "../../../../../../service/Meet/DeniedBoSungVanDesEndpoint";

const ModalVanDe = React.forwardRef((props, ref) => {
  const { isOpen, isClose, khungNoiDungId, data } = props;
  const [dataVD, setDataVD] = useState({
    mau: "BQ",
    loaiBieuQuyet: Enums_LoaiBieuQuyet[1].value,
    thamDus: "all",
  });
  const refPhuongAns = useRef();
  const refOldPath = useRef();
  const refDeny = useRef();

  const setNullData = useCallback(
    () =>
      setDataVD({
        mau: "BQ",
        loaiBieuQuyet: Enums_LoaiBieuQuyet[1].value,
        fileId: uuid(),
        thamDus: "all",
      }),
    [],
  );

  const getDataVanDe = useCallback(async (data) => {
    try {
      const { resultObj: files } = await BoSungVanDesEndpoint.getAllFile(
        data.fileId,
      );
      const { resultObj: deniedBoSungVanDes } =
        await DeniedBoSungVanDesEndpoint.getListDeny(data.id);
      const fileDinhKem = {};
      if (files.length > 0) {
        fileDinhKem["name"] = files[0].fileName;
        fileDinhKem["path"] = files[0].filePath;
        refOldPath.current = files[0].filePath;
      }
      let thamDus = "all";
      if (deniedBoSungVanDes.length > 0) {
        thamDus = "option";
      }
      setDataVD({
        ...data,
        phuongAns: data.phuongAnBoSungs,
        fileDinhKem,
        deniedBoSungVanDes,
        thamDus,
      });
    } catch (error) {}
  }, []);

  useEffect(() => {
    if (data) {
      getDataVanDe(data);
    } else {
      if (khungNoiDungId) setNullData();
    }
  }, [data, getDataVanDe, khungNoiDungId, setNullData]);

  const handleChange = useCallback(async (name, value, fileId = null) => {
    setDataVD((pre) => ({ ...pre, [name]: value }));
  }, []);

  const handleValidate = useCallback(() => {
    const initialNameData = ["dataVD"];
    const initialFormData = ["formDataVD"];
    const data = [{ dataVD, formDataVD }];
    for (let i = 0; i < data.length; i++) {
      const listRequired = Object.values(data[i][initialFormData[i]]).filter(
        (field) => field.required,
      );
      for (let index = 0; index < listRequired.length; index++) {
        const field = listRequired[index];
        let value =
          (data[i][initialNameData[i]] &&
            data[i][initialNameData[i]][field.field_name]) ||
          null;
        if (
          value === null ||
          value === "" ||
          value === undefined ||
          value.length === 0
        ) {
          CHECK_WARNING('Vui lòng nhập "' + field.title + '"');
          return false;
        }
      }
    }
    return true;
  }, [dataVD]);

  const save = useCallback(async () => {
    if (handleValidate()) {
      try {
        const saveAllFile = (data) =>
          Promise.all(data.map((cur) => BoSungVanDesEndpoint.UploadFile(cur)));
        if (data && data.id) {
          const { fileDinhKem, thamDus, ...dataEdit } = dataVD;
          const formPhuongAn = refPhuongAns.current;
          const dataUpdate = JSON.parse(JSON.stringify(dataEdit));
          delete dataUpdate["id"];
          delete dataUpdate["phuongAns"];
          delete dataUpdate["deniedBoSungVanDes"];
          if (thamDus === "all") {
            DeniedBoSungVanDesEndpoint.deleteDeny({ boSungVanDeId: dataVD.id });
          }
          await BoSungVanDesEndpoint.UpdateAUTH(`(${data.id})`, dataUpdate);
          if (fileDinhKem.size)
            await saveAllFile([
              {
                file: fileDinhKem,
                type: "BoSungVanDes",
                key: dataEdit.fileId,
                filePathRemove: refOldPath.current,
              },
            ]);
          if (formPhuongAn)
            await BoSungVanDesEndpoint.updatePhuongAn({
              boSungVanDeId: dataVD.id,
              phuongAns: formPhuongAn.getData(),
            });
          isClose();
        } else {
          const { fileDinhKem, thamDus, ...dataEdit } = dataVD;
          const phuongAns = refPhuongAns.current
            ? refPhuongAns.current.getData()
            : [];
          const d = {
            ...dataEdit,
            khungNoiDungId: khungNoiDungId,
            phuongAnBoSungs: phuongAns,
          };
          const listDenied = refDeny.current ? refDeny.current.getDeny() : null;
          if (listDenied)
            d["deniedBoSungVanDes"] = listDenied.map((cur) => ({
              thanhPhanThamDuId: cur,
            }));
          await BoSungVanDesEndpoint.addVanDes(d);
          fileDinhKem &&
            (await saveAllFile([
              {
                file: fileDinhKem,
                type: "BoSungVanDes",
                key: dataEdit.fileId,
                filePathRemove: refOldPath.current,
              },
            ]));
          isClose();
        }
      } catch (error) {
        CHECK_ERROR("Không thành công");
      }
    }
  }, [handleValidate, data, dataVD, isClose, khungNoiDungId]);

  const isShowThamDu = dataVD?.thamDus !== "all";
  return (
    <Modal
      className="modal-vande-modern"
      size={"xl"}
      isOpen={isOpen ? true : false}
      toggle={isClose}
    >
      {/* Custom Header */}
      <div className="vande-header">
        <div className="header-left">
          <div className="header-icon">
            <FontAwesome fa="list-ul" />
          </div>
          <div>
            <h5 className="header-title">
              {data?.id ? "Cập nhật vấn đề" : "Tạo mới vấn đề"}
            </h5>
            <p className="header-subtitle">Thông tin biểu quyết</p>
          </div>
        </div>
        <button className="header-close-btn" onClick={isClose}>
          <FontAwesome fa="times" />
        </button>
      </div>

      {/* Body - 3-panel layout */}
      <div className="vande-body">
        <Row>
          {/* Panel 1: Thông tin + Cấu hình */}
          <Col md={isShowThamDu ? "5" : "6"} className="prop-info">
            {/* Section: Thông tin vấn đề */}
            <div className="vande-section">
              <div className="section-title">
                <span className="section-icon">📋</span>
                Thông tin vấn đề
              </div>
              <FormControl
                data={formDataVD.name}
                value={(dataVD && dataVD.name) || null}
                onChange={handleChange}
              />
              <Row className="mr-0 ml-0 mt-2">
                <Col md="12" className="pl-0 pr-0">
                  <FormControl
                    data={formDataVD.mau}
                    value={(dataVD && dataVD.mau) || null}
                    onChange={handleChange}
                  />
                </Col>
                <Col md="12" className="pr-0 pl-0">
                  <FormControl
                    data={formDataVD.loai}
                    value={(dataVD && dataVD.loai) || null}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
            </div>

            {/* Section: Cấu hình biểu quyết */}
            <div className="vande-section">
              <div className="section-title">
                <span className="section-icon">⚙️</span>
                Cấu hình biểu quyết
              </div>
              <FormControl
                data={formDataVD.thamDus}
                value={(dataVD && dataVD.thamDus) || null}
                onChange={handleChange}
              />
              <div className="mt-2">
                <FormControl
                  data={formDataVD.fileDinhKem}
                  value={(dataVD && dataVD.fileDinhKem) || null}
                  onChange={handleChange}
                />
              </div>
            </div>
          </Col>

          {/* Panel 2: Phương án biểu quyết */}
          <Col md={isShowThamDu ? "4" : "6"} className="prop-info">
            <div className="vande-section vande-section-full">
              <div className="section-title">
                <span className="section-icon">🗳️</span>
                Phương án biểu quyết
              </div>
              {dataVD && dataVD.mau === "PA" ? (
                <PhuongAns
                  vanDeId={dataVD && dataVD.id}
                  ref={refPhuongAns}
                  data={dataVD && dataVD.phuongAns}
                />
              ) : (
                <div className="vande-badges-row">
                  <span className="vande-badge badge-agree">
                    <span className="badge-icon">✓</span>
                    Đồng ý
                  </span>
                  <span className="vande-badge badge-disagree">
                    <span className="badge-icon">✗</span>
                    Không đồng ý
                  </span>
                  <span className="vande-badge badge-other">
                    <span className="badge-icon">✎</span>Ý kiến khác
                  </span>
                </div>
              )}
            </div>
          </Col>

          {/* Panel 3: Danh sách tham dự (conditional) */}
          {isShowThamDu && (
            <Col md="3" className="vande-thamdu-panel">
              <div className="thamdu-divider" />
              <ThamDus ref={refDeny} dataVD={dataVD} />
            </Col>
          )}
        </Row>
      </div>

      {/* Footer */}
      <div className="vande-footer">
        <button className="btn-vande-save" onClick={save}>
          <FontAwesome fa="save" />
          <span>Lưu</span>
        </button>
        <button className="btn-vande-cancel" onClick={isClose}>
          <FontAwesome fa="times" />
          <span>Đóng</span>
        </button>
      </div>
    </Modal>
  );
});
export default ModalVanDe;
